<!-- 社区团购 -->
<template>
  <div class="warp">
    <div class="banner">
      <br />
      <p>绿茶社区团购系统</p>
      <span>
        社区团购小程序，快速
        <br />开启社区零售新模式
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="group1">
      <div class="title">绿茶社区团购系统功能特点</div>
      <ul class="list1">
        <li>
          <div class="left">
            <img src="../../assets/images/group02.png" />
          </div>
          <div class="right">
            <span>分享小程序/微商城</span>
            <p>
              商品名称、信息、图片一目了然，
              点开即可下单
            </p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/group03.png" />
          </div>
          <div class="right">
            <span>十余种营销玩法</span>
            <p>
              丰富的营销工具，轻松提升客户
              活跃度和粘性
            </p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/group04.png" />
          </div>
          <div class="right">
            <span>微信刷脸支付</span>
            <p>
              吸引更多新客加入，同时刺激消费
              购买茶产品
            </p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/group05.png" />
          </div>
          <div class="right">
            <span>切换团长/提货点</span>
            <p>
              根据定位为客户推荐附近的团长，
              也可自由切换
            </p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/group06.png" />
          </div>
          <div class="right">
            <span>商品分类</span>
            <p>
              设置商品分类，让客户快速找到
              所需商品
            </p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/group07.png" />
          </div>
          <div class="right">
            <span>显示购买信息</span>
            <p>
              浮动显示最近购买记录，展示
              商城
            </p>
          </div>
        </li>
      </ul>
      <div class="list2">
        <img src="../../assets/images/group08.jpg" />
      </div>
      <ul class="list3">
        <li>
          <img src="../../assets/images/group09.jpg" />
          <span>多城市合伙人</span>
        </li>
        <li>
          <img src="../../assets/images/group10.jpg" />
          <span>关联供应商</span>
        </li>
        <li>
          <img src="../../assets/images/group11.jpg" />
          <span>区域商品差异化</span>
        </li>
        <li>
          <img src="../../assets/images/group12.jpg" />
          <span>商品推广海报</span>
        </li>
        <li>
          <img src="../../assets/images/group13.jpg" />
          <span>代客下单</span>
        </li>
        <li>
          <img src="../../assets/images/group14.jpg" />
          <span>团长推荐奖励</span>
        </li>
        <li>
          <img src="../../assets/images/group15.jpg" />
          <span>多级团长</span>
        </li>
        <li>
          <img src="../../assets/images/group16.jpg" />
          <span>团长锁粉</span>
        </li>
        <li></li>
        <li>
          <img src="../../assets/images/group17.jpg" />
          <span>团长业绩考核</span>
        </li>
        <li>
          <img src="../../assets/images/group18.jpg" />
          <span>多种营销插件</span>
        </li>
        <li></li>
      </ul>
      <div class="list4">
        <img src="../../assets/images/group19.jpg" />
      </div>
    </div>
    <div class="group1">
      <div class="title">社区团购模式运作流程</div>
      <div class="list2">
        <img src="../../assets/images/group20.jpg" />
      </div>
    </div>

    <div class="group3">
      <div class="title" style="margin-top:-.5rem">解决不同的角色需求</div>
      <ul class="list4">
        <li>
          <img src="../../assets/images/group21.jpg" />
          <h3>社区团购企业</h3>
          <i></i>
          <span>整合上游货源，发展社区团长</span>
          <p>通过社区办拼团系统后台添加和管理社区团长，同意上传商品，管理订单，没财务结算，移动化管理不受限制。根据具体需求定制社区团购的截单时间，生成配送单，合理配备商品至各个社区团长。</p>
        </li>
        <li>
          <img src="../../assets/images/group22.jpg" />
          <h3>周边居民</h3>
          <i></i>
          <span>注重性价比，售后和购物体验</span>
          <p>通过社区团购小程序/微商城即可进入商品详情页，打开速度快，下单即可退出，购买体验更好。商品源头直采，价格更实惠，加上与社区团长间的邻里关系，无需担心售后问题。</p>
        </li>
        <li>
          <img src="../../assets/images/group23.jpg" />
          <h3>团长(社区合伙人)</h3>
          <i></i>
          <span>建立小区微信群，群内推广商品</span>
          <p>团长一键分享社区拼团小程序/微商城商品链接，可生成商品海报，图文描述更详尽。告别传统的手工统计和收单，系统自动提醒下单的居民到货，提货，佣金随时提现，结算更透明。</p>
        </li>
      </ul>
    </div>

    <div class="group4">
      <div class="title" style="margin-top:-.5rem">行业应用场景</div>
      <ul class="list5">
          <li>
              <img src="../../assets/images/group25.jpg">
              <span>食享会</span>
          </li>
          <li>
              <img src="../../assets/images/group26.jpg">
              <span>松鼠拼拼</span>
          </li>
          <li>
              <img src="../../assets/images/group27.jpg">
              <span>你我您</span>
          </li>
          <li>
              <img src="../../assets/images/group28.jpg">
              <span>呆萝卜</span>
          </li>
          <li>
              <img src="../../assets/images/group29.jpg">
              <span>十荟团</span>
          </li>
          <li>
              <img src="../../assets/images/group30.jpg">
              <span>苏果优选</span>
          </li>
          <li>
              <img src="../../assets/images/group31.jpg">
              <span>邻邻壹</span>
          </li>
          <li>
              <img src="../../assets/images/group32.jpg">
              <span>兴盛优选</span>
          </li>
          <li>
              <img src="../../assets/images/group33.jpg">
              <span>考拉精选</span>
          </li>
          <li>
              <img src="../../assets/images/group34.jpg">
              <span>苏小团</span>
          </li>
          <li>
              <img src="../../assets/images/group35.jpg">
              <span>小区乐</span>
          </li>
          <li>
              <img src="../../assets/images/group36.jpg">
              <span>友家铺子</span>
          </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "groupBuying",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/group01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #ffc600;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .title {
    font-size: 0.5rem;
    color: #262e43;
    padding: 1.2rem 0 0.5rem;
    text-align: center;
  }
  .group1 {
    .list1 {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        display: flex;
        padding: 0.5rem 0.34rem;
        .left {
          padding-right: 0.2rem;
          img {
            width: 0.8rem;
          }
        }
        .right {
          span {
            font-size: 0.34rem;
          }
          p {
            padding-top: 0.1rem;
            font-size: 0.32rem;
            color: #666;
            line-height: 0.55rem;
          }
        }
      }
    }
    .list2 {
      img {
        width: 100%;
      }
    }
    .list3 {
      padding: 0.3rem;
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 0.6rem;
      li {
        width: 25%;
        text-align: center;
        padding: 0.5rem 0;
        img {
          width: 0.8rem;
        }
        span {
          display: block;
          padding-top: 0.3rem;
          color: #262e43;
          font-size: 0.3rem;
        }
      }
    }
  }
  .group3 {
    .list4 {
      text-align: center;
      li {
        padding-bottom: 0.8rem;
        img {
          width: 100%;
        }
        h3 {
          font-size: 0.44rem;
          color: #e75b4f;
          font-weight: 500;
          padding-bottom: 0.1rem;
        }
        i {
          width: 1rem;
          height: 1px;
          background-color: #000;
          display: block;
          margin: auto;
        }
        span {
          font-size: 0.32rem;
          color: #262e43;
          display: block;
          padding: 0.2rem 0;
        }
        p {
          font-size: 0.3rem;
          color: #888888;
          padding: 0 0.5rem;
          line-height: 0.5rem;
        }
      }
    }
  }
  .group4{
      .list5{
          background: url('../../assets/images/group24.jpg') no-repeat center center;
          background-size: 100% auto;
          display: flex;
          flex-wrap: wrap;
          padding: .3rem;
          padding-top: 0;
          li{
              width: 25%;
              text-align: center;
              padding: .4rem 0;
              img{
                  width: 1.4rem;
              }
              span{
                  display: block;
                  font-size: .3rem;
                  padding: .15rem 0;
              }
          }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/groupBuying.vue